import { ProductVariant } from '../data/products';

/**
 * Universal add-to-cart handler for any product type
 * Abstracts the common logic of creating a CartItem from a product and variant
 */
export interface AddToCartParams {
  productId: string;
  handle: string;
  title: string;
  image: string;
  variant: ProductVariant;
  quantity?: number;
}

export const addProductToCart = (
  { productId, handle, title, image, variant, quantity = 1 }: AddToCartParams,
  addItem: (item: any, quantity?: number) => void
): void => {
  addItem(
    {
      productId,
      handle,
      title,
      variantLabel: variant.label,
      variantValue: variant.value,
      stripePriceId: variant.stripePriceId,
      priceCents: variant.priceCents,
      priceDisplay: variant.priceDisplay,
      image,
    },
    quantity
  );
};
